import { createTheme, responsiveFontSizes, Theme } from "@mui/material/styles";
export default responsiveFontSizes(
  createTheme({
    typography: {
      fontFamily: ["Lato", "sans-serif", "-apple-system"].join(","),
    },

    components: {
      MuiButton: {
        styleOverrides: {
          root: {
            textTransform: "capitalize",
            fontWeight: 600,
            "&:hover": {
              backgroundColor: "",
            },
          },
          sizeSmall: {
            color: "#fff",
          },
          sizeMedium: {
            color: "#fff",
          },
          sizeLarge: {
            color: "#fff",
          },
        },
      },
      MuiFab: {
        styleOverrides: {
          root: {},
        },
      },
      MuiSvgIcon: {
        styleOverrides: {
          root: {},
        },
      },
      MuiStepIcon: {
        styleOverrides: {
          text: {
            fill: "#fff",
          },
          root: {
            width: "1.5em",
            height: "1.5em",
          },
        },
      },

      MuiAppBar: {
        styleOverrides: {
          root: {
            backgroundColor: "#fff",
            boxShadow:
              "0px 2px 1px -1px rgb(0 0 0 / 1%), 0px 4px 5px 0px rgb(0 0 0 / 6%), 0px 1px 2px 0px rgb(0 0 0 / 1%)",
            color: "inherit",
          },
        },
      },
    },
    palette: {
      //mode: 'dark',
      primary: {
        // light: will be calculated from palette.primary.main,
        main: "#22A3F9",
        light: "#338FFA",
        contrastText: "#42a5f5",
        dark: "#008be7",
        //contrastText: "#fff",
      },
      secondary: {
        main: "#d0d0d8",
        light: "#D9D9DF",
        dark: "#919197",
        // dark: will be calculated from palette.secondary.main,
        //contrastText: '#1976d2',
      },
      // Provide every color token (light, main, dark, and contrastText) when using
      // custom colors for props in Material UI's components.
      // Then you will be able to use it like this: `<Button color="custom">`
      // (For TypeScript, you need to add module augmentation for the `custom` value)
      // custom: {
      //   light: '#ffa726',
      //   main: '#f57c00',
      //   dark: '#ef6c00',
      //   contrastText: 'rgba(0, 0, 0, 0.87)',
      // },
      // Used by `getContrastText()` to maximize the contrast between
      // the background and the text.
      contrastThreshold: 3,
      // Used by the functions below to shift a color's luminance by approximately
      // two indexes within its tonal palette.
      // E.g., shift from Red 500 to Red 300 or Red 700.
      tonalOffset: 0.2,
    },
  })
);

declare module "@mui/material/styles" {
  interface Theme {
    status: {
      danger: string;
    };
  }
  // allow configuration using `createTheme`
  interface ThemeOptions {
    status?: {
      danger?: string;
    };
  }
}

